import * as d3 from "d3"

export type ShellChartData<T> = {
    color: string,
} & T

export type ShellChartOption<T> = {
    x: (d: T) => number,
    gap?: number,
    innerRadius?: number,
    sorting: (a: T, b: T) => number
}
// SunBurstChart
export default function ShellChart<T>(node: HTMLElement, data: ShellChartData<T>[], option: ShellChartOption<T>) {
    // Compute values.
    const {
        gap = 1,
        x,
        sorting
    } = option;

    const { width, height } = node.getBoundingClientRect();
    const maxOuterRadiuse = Math.min(width, height) / 2;

    const innerRadius = maxOuterRadiuse / 2
    // SVG
    const svg = d3.create("svg")
        .attr("width", width)
        .attr("height", height)
        .attr("viewBox", `0, 0, ${width}, ${height}`)
        .attr("style", "max-width: 100%;")


    const pie = d3.pie<T>()
        .sort(sorting)
        .value(d => x(d))
    // 
    data.forEach((v, i) => {
        const g = svg.append('g')
            .attr("index", String(i))
            .attr('transform', `translate(${width / 2}, ${height / 2})`);
        const arcs = pie(data)
        const arc = d3.arc().innerRadius(innerRadius).outerRadius(maxOuterRadiuse - (gap * i));

        g
            .selectAll('path')
            .data(arcs)
            .enter()
            .append('path')
            .attr('fill', (d, index) => i === index ? data[i].color : "transparent")
            .attr('d', arc as unknown as () => string)
    })


    node.appendChild(svg.node() as SVGSVGElement)
    let timeout: any
    const resizeEvent = () => {
        const { width, height } = node.getBoundingClientRect();
        const maxOuterRadiuse = Math.min(width, height) / 2;
        const innerRadius = maxOuterRadiuse / 2
        if (timeout) {
            clearTimeout(timeout)
        }
        timeout = setTimeout(() => {
            svg.attr("width", width)
                .attr("height", height)
                .attr("viewBox", `0, 0, ${width}, ${height}`)

            data.forEach((v, i) => {
                const g = svg
                    .select(`g[index='${i}']`)
                    .attr('transform', `translate(${width / 2}, ${height / 2})`);
                const arcs = pie(data)
                const arc = d3.arc().innerRadius(innerRadius).outerRadius(maxOuterRadiuse - (gap * i));
                g
                    .selectAll('path')
                    .attr('d', arc as unknown as () => string)
            })
        }, 100)



        // SVG

    }

    window.addEventListener("resize", resizeEvent)

    return {
        node: svg.node() as SVGSVGElement,
        resizeEvent
    }
}